import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { CHAT_GPT, REST_API } from 'drapcode-constant';
import * as actions from '../../features/external-api/redux/actions';
import * as commonActions from '../../features/common/redux/actions';
import CustomLoader from '../common/CustomLoader';
import RestAPIExternalApiForm from './rest-api/RestAPIExternalApiForm';
import ExternalApiHeaderNav from './ExternalApiHeaderNav';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { checkToShowSaveBtn } from '../plugin/utils';
import { parseExtractPluginCode } from '../../common/utils/plugin_utils';
import { checkExternalAPIPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class ExternalApiTabBar extends Component {
  static propTypes = {
    externalapi: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { headers: [] };

  componentDidMount = async () => {
    const { match, home, actions } = this.props;
    const { projectId, externalApiId, version } = match.params;
    const { iPlugins } = home;
    await actions.loadCollections({ projectId, version });
    if (externalApiId) {
      await actions.loadExternalApi({ externalApiId, projectId, version });
    }
    const headers = parseExtractPluginCode(iPlugins, 'EXTERNALAPI');
    this.setState({ headers });

    // here we have to call api to get active tabs in edit page
    const externalApisForTab = await actions.loadExternalDatabase({ projectId, version });
    if (externalApisForTab) {
      const dataTypes = [...new Set(externalApisForTab.map((item) => item.type))];
      this.setState({ headers: dataTypes });
    }
    actions.loadProjectDetail({ projectId, version });
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { home: nextHome, match } = nextProps;
    const { home } = this.props;
    const { iPlugins: nextIPlugins } = nextHome;
    if (!nextIPlugins || nextIPlugins.length === 0) {
      return true;
    }
    const { iPlugins } = home;
    if (!checkToShowSaveBtn(nextIPlugins, iPlugins)) {
      const headers = parseExtractPluginCode(nextIPlugins, 'EXTERNALAPI');
      this.setState({ headers });
    }
    return true;
  }
  componentDidUpdate(prevProps) {
    const { projectDetail } = this.props.common;
    if (prevProps.common.projectDetail !== projectDetail) {
      if (projectDetail && projectDetail.projectType) {
        const { projectType } = projectDetail;
      }
    }
  }
  showCreateForm = () => {
    const { projectId, version } = this.props.match.params;

    return (
      <RestAPIExternalApiForm
        projectId={projectId}
        externalApiId={''}
        history={this.props.history}
        externalApiType={REST_API}
        actions={this.props.actions}
        externalapi={this.props.externalapi}
        version={version}
      />
    );
  };

  showUpdateForm = () => {
    const { match, externalapi, actions, history } = this.props;
    const { loadExternalApiPending, loadCollectionsPending } = externalapi;
    if (loadCollectionsPending || loadExternalApiPending) {
      return (
        <div className="text-center">
          <CustomLoader loading={loadExternalApiPending} size="20px" color="#303453" />
        </div>
      );
    }
    const { projectId, externalApiId, version } = match.params;
    return (
      <RestAPIExternalApiForm
        projectId={projectId}
        externalApiId={externalApiId}
        history={history}
        actions={actions}
        externalapi={externalapi}
        version={version}
        externalApiType={this.activeTab()}
      />
    );
  };

  activeTab = () => {
    const { externalapi } = this.props;
    const { externalApiData } = externalapi || '';
    const { externalApiType } = externalApiData || '';

    return externalApiType ? externalApiType : REST_API;
  };

  render() {
    const isAllowed = checkExternalAPIPermission();
    if (!isAllowed) {
      return <PermissionDenied message="External APIs" />;
    }

    const { externalApiId, projectId, version } = this.props.match.params;
    const { home } = this.props;
    const { iPlugins } = home || '';

    const chatGptPlugin = iPlugins && iPlugins.find((e) => e.code === CHAT_GPT);
    const { headers } = this.state;
    return (
      <CommonPageComponent>
        <ExternalApiHeaderNav
          version={version}
          activeTab={this.activeTab()}
          projectId={projectId}
          headers={headers}
          enableChatGpt={chatGptPlugin ? true : false}
        />
        {externalApiId ? this.showUpdateForm() : this.showCreateForm()}
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    externalapi: state.externalapi,
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalApiTabBar);
